import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ToolTipWrapper from "../../../CommonComponents/ToolTipComponent/ToolTipWrapper";
import { formatUnixTimestampToHumanReadableFormat } from '../../../utils/DateUtils';

const Header = ({
    trackingRecord = {},
    submissionRecord = null,
    onDownloadSubmission,
    onDownloadProcessed,
    isAdminUser
}) => {
    const toolTipData = (data) => {
        if (!data?.createdOn) {
            return null;
        }

        return (
            <ToolTipWrapper
                id="audit-details"
                text={data.modifiedBy ? `Created on ${formatUnixTimestampToHumanReadableFormat(data.createdOn)}. Modified by ${data.modifiedBy} on ${formatUnixTimestampToHumanReadableFormat(data.modifiedOn)}.` : `Created on ${formatUnixTimestampToHumanReadableFormat(data.createdOn)}.`}
                element={<i className="fa fa-question-circle"></i>}
                placement={"right"}
                style={{ fontSize: "1.25rem" }}
            />
        );
    };

    const handleDownloadFile = (url, fileName = undefined) => {
        const link = document.createElement('a');
        link.href = url;
        if (fileName) {
            link.download = fileName;
        }
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleExportValidationErrors = (validationErrorCsv) => {
        const blob = new Blob([validationErrorCsv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        handleDownloadFile(url, `${submissionRecord.participantName}_${submissionRecord.surveyYear}_ECS_Survey_Validation.csv`);
    }

    return (
        <div className="header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
                <h2 className="mb-0">
                    Survey Questionnaire Details<span className="d-flex align-items-center">{toolTipData(trackingRecord)}</span>
                    {trackingRecord && (
                        trackingRecord.sensitive ? (
                            <span className="badge bg-danger text-white px-2 py-1 fs-6 d-flex align-items-center">
                                <i className="fa fa-exclamation-triangle me-1" />Sensitive
                            </span>
                        ) : (
                            <span className="badge bg-success text-white px-2 py-1 fs-6 d-flex align-items-center">
                                <i className="fa fa-check-circle me-1" />Not Sensitive
                            </span>
                        )
                    )}
                </h2>
            </div>
            {isAdminUser && (
                <div className="d-flex gap-2">
                    <Button
                        variant="outline-primary"
                        size="lg"
                        onClick={() => onDownloadSubmission(submissionRecord?.fileKey)}
                        disabled={!submissionRecord?.fileKey}
                        title="Download Latest Submission file"
                    >
                        <i className="fa fa-download me-2" />Latest Submission
                    </Button>
                    {submissionRecord?.processedFileKey && (
                        <Button
                            variant="outline-primary"
                            size="lg"
                            onClick={() => onDownloadProcessed(submissionRecord.processedFileKey)}
                            title="Download processed file"
                        >
                            <i className="fa fa-file-alt me-2" />Processed File
                        </Button>
                    )}
                    {submissionRecord?.validationErrorCsv && (
                        <Button
                            variant="outline-primary"
                            size="lg"
                            onClick={() => handleExportValidationErrors(submissionRecord.validationErrorCsv)}
                            title="Export validation errors"
                        >
                            <i className="fa fa-file-excel me-2" />Export Validation Errors
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

Header.propTypes = {
    trackingRecord: PropTypes.shape({
        createdOn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        modifiedOn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        modifiedBy: PropTypes.string,
        sensitive: PropTypes.bool,
        participantName: PropTypes.string
    }),
    isAdminUser: PropTypes.bool.isRequired,
    submissionRecord: PropTypes.shape({
        fileKey: PropTypes.string,
        processedFileKey: PropTypes.string,
        validationErrorsCsv: PropTypes.string
    }),
    onDownloadSubmission: PropTypes.func.isRequired,
    onDownloadProcessed: PropTypes.func.isRequired
};

export default Header; 